/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridOptions } from '@ag-grid-community/core';
/* eslint-disable @typescript-eslint/no-this-alias */
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GridOptionsExt } from '../ag-grid';

@Component({
    selector: 'prox-quick-search',
    templateUrl: './quick-search.component.html',
    standalone: false
})
export class QuickSearchComponent {
  @Input() gridOptions!: GridOptionsExt;
  
  form = new FormGroup({
    filter: new FormControl('')
  });
  get filter(): any { return this.form.get('filter'); }

  timeout: any = "";

  onFilterInputChanged(e: any) {
    clearTimeout(this.timeout);
    const this_ = this;
    this.timeout = setTimeout(function () {
      if (e.keyCode != 13) {
        this_.gridOptions.apiX?.setGridOption('quickFilterText', e.target.value);
      }
    }, 500);
  }

  onClearSearch(e: any) {
    this.gridOptions.apiX?.setGridOption('quickFilterText', "");
    this.filter.reset()
  }

}
